const DualFormRequirement = {
  QDD: 1,
  DisregardedEntity: 2,
  HybridEntities: 4
};

export default DualFormRequirement;
